import req from "../http";

const userLogin = {
  // 取得 登入紀錄資料
  getUserLoginRecord(params) {
    return req("post", "/Report/UserLoginRecord/Detail", params);
  },

  // 取得 登入紀錄圖表
  getUserLoginChart(params) {
    return req("get", "/Report/UserLoginRecord/Chart", params);
  },

  // 下載 登入紀錄報表
  downloadUserLoginRecord(params) {
    return req("post", "/Report/UserLoginRecord/DetailExport", params, { responseType: "blob" });
  }
};

export default userLogin;